module.exports = __webpack_public_path__ + "static/media/CZF.64143495.png";